import script from "./HomeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSection.vue?vue&type=script&setup=true&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=f015913e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f015913e"]])

export default __exports__